import { ChangeDetectionStrategy, Component } from '@angular/core';

interface SpectrumBar {
  height: number;
  hi: boolean;
}

const HEIGHTS: ReadonlyArray<number> = [
  0.3, 0.5, 0.4, 0.6, 0.45, 0.7, 0.55, 0.85, 0.65, 0.9, 0.75, 1, 0.85, 0.7, 0.6, 0.5, 0.4, 0.35
];

@Component({
  selector: 'auth-spectrum-accent',
  templateUrl: './spectrum-accent.component.html',
  styleUrls: ['./spectrum-accent.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false
})
export class SpectrumAccentComponent {
  readonly bars: ReadonlyArray<SpectrumBar> = HEIGHTS.map((h: number): SpectrumBar => ({ height: h, hi: h >= 0.85 }));
}
